export const workspaceConstants = {
  WORKSPACE_LOAD: '[Workspace] Load',
  WORKSPACE_LOAD_SUCCESS: '[Workspace] Load success',
  WORKSPACE_LOAD_FAILURE: '[Workspace] Load failure',
  WORKSPACE_RESET: '[Workspace] Reset'
}
